import { render } from "./bounsHistory.vue?vue&type=template&id=7f514c81&scoped=true"
import script from "./bounsHistory.vue?vue&type=script&lang=js"
export * from "./bounsHistory.vue?vue&type=script&lang=js"

import "./bounsHistory.vue?vue&type=style&index=0&id=7f514c81&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f514c81"]])

export default __exports__